export default {
  errTooManyRequests: {
    zh_cn: '请求过于频繁，请稍后再试',
    zhhant: '請求過多，請稍後再試',
    en: 'Too many requests, please try again later.',
    he: 'מבוקשים יותר מדי, נא לנסות שוב מאוחר יותר.',
    de: 'Zu viele Anfragen, bitte versuchen Sie es später nochmal.',
    es: 'Demasiadas solicitudes, por favor inténtalo de nuevo más tarde.',
    ru: 'Запросов слишком много, пожалуйста, повторите позже.',
    vi: 'Yêu cầu quá nhiều, vui lòng thử lại sau.',
  },
  errOrderPriceTariffsTagConfig: {
    zh_cn: '定价内容错误。 相同标签的价格必须一致。',
    zhhant: '定價內容錯誤。 相同標籤的價格必須一樣。',
    en: 'Pricing content error. The price of the same tag must be consistent.',
    he: 'שגיאת תוכן מחיר. הערות שכותקים של תג חייב להיות זהה.',
    de: 'Preisinhalt-Fehler. Die Preise derselben Bezeichnung müssen konsistent sein.',
    es: 'Error de contenido de precios. Los precios de la misma etiqueta deben ser consistentes.',
    ru: 'Ошибка контента ценовой политики. Цена с тем же меткой должна быть согласованной.',
    vi: 'Lỗi nội dung giá cả. Giá của một thẻ giống nhau phải là đồng nhất.',
  },
  errNotSupport: {
    zh_cn: '不支持的请求',
    en: 'Not supported request',
    zhhant: '不支援的請求',
    he: 'לא נתמך בבקשה',
    de: 'Nicht unterstützte Anfrage',
    es: 'Solicitud no admitida',
    ru: 'Запрос не поддерживается',
    vi: 'Yêu cầu không được hỗ trợ',
  },
  errCanceled: {
    zh_cn: '已取消，请再次请求',
    en: 'Cancelled, please request again.',
    zhhant: '已取消，請再次請求',
    he: 'מבוטל, נא לבקש שוב.',
    de: 'Abgebrochen, bitte erneut anfordern.',
    es: 'Cancelado, por favor solicite nuevamente.',
    ru: 'Отменено, пожалуйста, запросите снова.',
    vi: 'Đã hủy, vui lòng yêu cầu lại.',
  },
  errUnknown: {
    zh_cn: '未知错误',
    en: 'Unknown',
    zhhant: '未知錯誤',
    he: 'לא ידוע',
    de: 'Unbekannt',
    es: 'Desconocido',
    ru: 'Неизвестно',
    vi: 'Không xác định',
  },
  errInvalidArgument: {
    zh_cn: '无效的请求参数，请检查输入是否正确?',
    en: 'Invalid request parameters, please check whether the input is correct?',
    zhhant: '無效的請求參數，請檢查輸入是否正確？',
    he: 'פרמטרים לא חוקיים, נא לבדוק אם הקלט נכון.',
    de: 'Ungültige Anforderungsparameter, bitte überprüfen Sie, ob die Eingabe korrekt ist.',
    es: 'Parámetros de solicitud no válidos, por favor verifique si la entrada es correcta.',
    ru: 'Неверные параметры запроса, проверьте правильность ввода.',
    vi: 'Tham số yêu cầu không hợp lệ, vui lòng kiểm tra xem đầu vào có đúng không?',
  },
  errDeadlineExceeded: {
    zh_cn: '请求超时',
    en: 'Deadline exceeded',
    zhhant: '請求超時',
    he: 'עבר המועד האחרון',
    de: 'Frist überschritten',
    es: 'Se ha superado el plazo',
    ru: 'Время ожидания истекло',
    vi: 'Hết thời gian yêu cầu',
  },
  errNotFound: {
    zh_cn: '主体不存在, 请检查请求参数!',
    en: 'Request OBJ does not exist, please check request parameters!',
    zhhant: '主體不存在，請檢查請求參數！',
    he: 'האובייקט לא קיים, נא לבדוק את פרמטרי הבקשה!',
    de: 'Anforderungs-Objekt existiert nicht, bitte überprüfen Sie die Anfrageparameter!',
    es: 'El objeto de solicitud no existe, ¡por favor, verifique los parámetros de la solicitud!',
    ru: 'Объект запроса не существует, проверьте параметры запроса!',
    vi: 'Đối tượng yêu cầu không tồn tại, vui lòng kiểm tra các tham số yêu cầu!',
  },
  errAlreadyExists: {
    zh_cn: '主体已存在, 请勿重复操作!',
    en: 'OBJ already exists, please do not repeat the operation!',
    zhhant: '主體已存在，請勿重複操作！',
    he: 'האובייקט כבר קיים, נא לא לחזור על הפעולה!',
    de: 'Objekt existiert bereits, bitte nicht wiederholen!',
    es: 'El objeto ya existe, ¡por favor no repita la operación!',
    ru: 'Объект уже существует, не повторяйте операцию!',
    vi: 'Đối tượng đã tồn tại, vui lòng không lặp lại thao tác!',
  },
  errPermissionDenied: {
    zh_cn: '权限不足',
    en: 'Permission denied',
    zhhant: '權限不足',
    he: 'הרשאות נדחו',
    de: 'Zugriff verweigert',
    es: 'Permiso denegado',
    ru: 'Доступ запрещен',
    vi: 'Quyền truy cập bị từ chối',
  },
  errResourceExhausted: {
    zh_cn: '稍后重试',
    en: 'Resource exhausted',
    zhhant: '稍後重試',
    he: 'משאבים אזלו',
    de: 'Ressourcen erschöpft',
    es: 'Recurso agotado',
    ru: 'Ресурсы исчерпаны',
    vi: 'Tài nguyên đã hết',
  },
  errFailedPrecondition: {
    zh_cn: '操作前置条件不满足',
    en: 'Failed precondition',
    zhhant: '操作前置條件不滿足',
    he: 'המצב הקודם נכשל',
    de: 'Voraussetzung fehlgeschlagen',
    es: 'Condición previa fallida',
    ru: 'Не выполнены предварительные условия',
    vi: 'Điều kiện tiên quyết không thành công',
  },
  errAborted: {
    zh_cn: '操作终止, 请稍后再试',
    en: 'Aborted, please try again later!',
    zhhant: '操作終止，請稍後再試',
    he: 'הפעולה בוטלה, נא לנסות שוב מאוחר יותר!',
    de: 'Abgebrochen, bitte versuchen Sie es später noch einmal!',
    es: 'Abortado, ¡por favor intente de nuevo más tarde!',
    ru: 'Операция прервана, попробуйте позже!',
    vi: 'Hoạt động bị hủy, vui lòng thử lại sau!',
  },
  errOutOfRange: {
    zh_cn: '系统错误, 请求联系管理员',
    en: 'Out of range',
    zhhant: '系統錯誤，請求聯繫管理員',
    he: 'שגיאת מערכת, נא לפנות למנהל',
    de: 'Systemfehler, bitte den Administrator kontaktieren',
    es: 'Error del sistema, contacte con el administrador',
    ru: 'Системная ошибка, обратитесь к администратору',
    vi: 'Lỗi hệ thống, vui lòng liên hệ với quản trị viên',
  },
  errUnimplemented: {
    zh_cn: '方法未实现, 请求联系管理员',
    en: 'Unimplemented, Please contact the administrator !',
    zhhant: '方法未實現，請求聯繫管理員',
    he: 'שיטה לא מיושמת, נא לפנות למנהל!',
    de: 'Nicht implementiert, bitte den Administrator kontaktieren!',
    es: 'No implementado, ¡por favor contacte al administrador!',
    ru: 'Не реализовано, пожалуйста, обратитесь к администратору!',
    vi: 'Chưa thực hiện, vui lòng liên hệ với quản trị viên!',
  },
  errInternal: {
    zh_cn: '系统错误, 请求联系管理员',
    en: 'Internal Error. Please contact the administrator !',
    zhhant: '系統錯誤，請求聯繫管理員',
    he: 'שגיאה פנימית, נא לפנות למנהל!',
    de: 'Interner Fehler. Bitte kontaktieren Sie den Administrator!',
    es: 'Error interno. ¡Por favor contacte al administrador!',
    ru: 'Внутренняя ошибка. Пожалуйста, свяжитесь с администратором!',
    vi: 'Lỗi hệ thống. Vui lòng liên hệ với quản trị viên!',
  },
  errUnavailable: {
    zh_cn: '系统繁忙, 请稍后再试',
    en: 'Unavailable. please try again later!',
    zhhant: '系統繁忙，請稍後再試',
    he: 'לא זמין, נא לנסות שוב מאוחר יותר!',
    de: 'Nicht verfügbar. Bitte versuchen Sie es später erneut!',
    es: 'No disponible. ¡Por favor, intente de nuevo más tarde!',
    ru: 'Недоступно. Пожалуйста, попробуйте позже!',
    vi: 'Không khả dụng. Vui lòng thử lại sau!',
  },
  errDataLoss: {
    zh_cn: '数据丢失,请联系管理员!',
    en: 'Data loss',
    zhhant: '數據丟失，請聯繫管理員！',
    he: 'אובדן נתונים, נא לפנות למנהל!',
    de: 'Datenverlust, bitte wenden Sie sich an den Administrator!',
    es: 'Pérdida de datos. ¡Por favor, contacte al administrador!',
    ru: 'Потеря данных, пожалуйста, свяжитесь с администратором!',
    vi: 'Mất dữ liệu, vui lòng liên hệ với quản trị viên!',
  },
  errUnauthenticated: {
    zh_cn: '没有鉴权, 请重试',
    en: 'Unauthenticated',
    zhhant: '沒有鑑權，請重試',
    he: 'לא מאומת',
    de: 'Nicht authentifiziert',
    es: 'No autenticado',
    ru: 'Неаутентифицировано',
    vi: 'Chưa xác thực',
  },

  errAccountNotFound: {
    zh_cn: '用户错误码',
    en: 'Account not found',
    zhhant: '用戶錯誤碼',
    he: 'קוד שגיאה של משתמש',
    de: 'Benutzerfehlercode',
    es: 'Código de error de usuario',
    ru: 'Код ошибки пользователя',
    vi: 'Mã lỗi người dùng',
  },
  errPasswordError: {
    zh_cn: '密码错误',
    en: 'Password error',
    zhhant: '密碼錯誤',
    he: 'שגיאת סיסמה',
    de: 'Passwortfehler',
    es: 'Error de contraseña',
    ru: 'Ошибка пароля',
    vi: 'Lỗi mật khẩu',
  },
  errAuthRequestError: {
    zh_cn: '第三方请求授权失败，请检查参数',
    zhhant: '第三方請求授權失敗，請檢查參數',
    en: 'the third party fails to request authorization. Check the parameters',
    he: 'הבקשה לאישור של צד שלישי נכשלה, בדוק את הפרמטרים',
    de: 'Die Anfrage zur Autorisierung des Drittanbieters ist fehlgeschlagen. Prüfen Sie die Parameter',
    es: 'La solicitud de autorización de terceros falló. Compruebe los parámetros',
    ru: 'Запрос авторизации от сторонних сторон не удался. Проверьте параметры',
    vi: 'Yêu cầu ủy quyền bên thứ ba thất bại, vui lòng kiểm tra các thông số',
  },
  errNotLogin: {
    zh_cn: '没有登陆, 请先登录',
    en: 'Not login, Please Login.',
    zhhant: '沒有登錄，請先登錄',
    he: 'לא מחובר, נא להתחבר.',
    de: 'Nicht eingeloggt, bitte anmelden.',
    es: 'No ha iniciado sesión, por favor inicie sesión.',
    ru: 'Не выполнен вход, пожалуйста, войдите.',
    vi: 'Chưa đăng nhập, vui lòng đăng nhập.',
  },
  errNotSupportTmpl: {
    zh_cn: '不支持的模版',
    en: 'Not support tmpl',
    zhhant: '不支持的模板',
    he: 'תבנית שאינה נתמכת',
    de: 'Nicht unterstützte Vorlage',
    es: 'Plantilla no compatible',
    ru: 'Шаблон не поддерживается',
    vi: 'Mẫu không được hỗ trợ',
  },
  errChannelConfigError: {
    zh_cn: '渠道配置异常, 请联系管理员!',
    en: 'Channel Config Abnormal. Please contact the administrator!',
    zhhant: '渠道配置異常，請聯繫管理員！',
    he: 'תצורת ערוץ חריגה. אנא פנה למנהל!',
    de: 'Kanal-Konfiguration abnormal. Bitte kontaktieren Sie den Administrator!',
    es: 'Configuración de canal anormal. ¡Por favor, contacte al administrador!',
    ru: 'Аномальная конфигурация канала. Пожалуйста, свяжитесь с администратором!',
    vi: 'Cấu hình kênh bất thường. Vui lòng liên hệ với quản trị viên!',
  },
  errInsufficientFunds: {
    zh_cn: '钱包余额不足',
    en: 'Insufficient funds',
    zhhant: '錢包餘額不足',
    he: 'אין מספיק כספים',
    de: 'Unzureichende Mittel',
    es: 'Fondos insuficientes',
    ru: 'Недостаточно средств',
    vi: 'Số dư ví không đủ',
  },
  errNotSupportRegisterType: {
    zh_cn: '不支持的注册类型',
    en: 'Not support register type',
    zhhant: '不支持的註冊類型',
    he: 'סוג רישום שאינו נתמך',
    de: 'Nicht unterstützter Registrierungstyp',
    es: 'Tipo de registro no soportado',
    ru: 'Тип регистрации не поддерживается',
    vi: 'Loại đăng ký không được hỗ trợ',
  },
  errVerifyCodeExpired: {
    zh_cn: '验证码过期',
    en: 'Verify code expired',
    zhhant: '驗證碼過期',
    he: 'קוד האימות פג תוקף',
    de: 'Überprüfungscode abgelaufen',
    es: 'Código de verificación expirado',
    ru: 'Код подтверждения истек',
    vi: 'Mã xác minh đã hết hạn',
  },
  errVerifyCodeNotMatch: {
    zh_cn: '验证码不匹配',
    en: 'Verify code not match',
    zhhant: '驗證碼不匹配',
    he: 'קוד האימות אינו תואם',
    de: 'Überprüfungscode stimmt nicht überein',
    es: 'Código de verificación no coincide',
    ru: 'Код подтверждения не совпадает',
    vi: 'Mã xác minh không khớp',
  },
  errHasUnsettledorders: {
    zh_cn: 'wallet',
    en: 'Has unsettledorders',
    zhhant: 'wallet',
    he: 'יש הזמנות בלתי סודרות',
    de: 'Hat unbezahlte Bestellungen',
    es: 'Tiene pedidos no saldados',
    ru: 'Имеются неоплаченные заказы',
    vi: 'Có đơn hàng chưa thanh toán',
  },
  errAmountNotSame: {
    zh_cn: '金额不一致',
    en: 'Amount not same',
    zhhant: '金額不一致',
    he: 'סכום שאינו תואם',
    de: 'Betrag stimmt nicht überein',
    es: 'Cantidad no coincide',
    ru: 'Сумма не совпадает',
    vi: 'Số tiền không giống nhau',
  },
  errPaymentOrderStatusError: {
    zh_cn: '订单支付状态异常，请重新下单',
    en: 'Payment order status error',
    zhhant: '訂單支付狀態異常，請重新下單',
    he: 'שגיאת מצב הזמנה לתשלום, נא לבצע הזמנה מחדש',
    de: 'Fehler im Zahlungsstatus der Bestellung, bitte bestellen Sie erneut',
    es: 'Error en el estado del pedido de pago, por favor realice el pedido de nuevo',
    ru: 'Ошибка статуса платежного заказа, пожалуйста, сделайте заказ снова',
    vi: 'Lỗi trạng thái đơn hàng thanh toán, vui lòng đặt hàng lại',
  },
  errNotSupportPostpaymentMode: {
    zh_cn: '不支持的后付费支付模式',
    en: 'Not support postpayment mode',
    zhhant: '不支持的後付費支付模式',
    he: 'מצב תשלום מאוחר אינו נתמך',
    de: 'Nicht unterstützter Nachzahlungmodus',
    es: 'Modo de pago posterior no soportado',
    ru: 'Режим постоплаты не поддерживается',
    vi: 'Chế độ thanh toán sau không được hỗ trợ',
  },
  errAmountIsNil: {
    zh_cn: '金额是0',
    en: 'Amount is Zero',
    zhhant: '金額是0',
    he: 'הסכום הוא אפס',
    de: 'Betrag ist Null',
    es: 'La cantidad es cero',
    ru: 'Сумма равна нулю',
    vi: 'Số tiền là 0',
  },
  errEvseOffline: {
    zh_cn: '设备离线',
    en: 'Evse offline',
    zhhant: '設備離線',
    he: 'EVSE לא מקוון',
    de: 'EVSE offline',
    es: 'EVSE sin conexión',
    ru: 'EVSE не доступен',
    vi: 'EVSE không có kết nối',
  },
  errEvseNotOperation: {
    zh_cn: '设备未运营',
    en: 'Evse not operation',
    zhhant: '設備未運營',
    he: 'EVSE אינו פועל',
    de: 'EVSE nicht in Betrieb',
    es: 'EVSE no operativo',
    ru: 'EVSE не работает',
    vi: 'EVSE không hoạt động',
  },
  errEvseTimeout: {
    zh_cn: '设备响应超时',
    en: 'Evse timeout',
    zhhant: '設備響應超時',
    he: 'פג זמן התגובה של EVSE',
    de: 'EVSE-Timeout',
    es: 'Tiempo de espera de EVSE',
    ru: 'Тайм-аут EVSE',
    vi: 'Thời gian chờ EVSE',
  },
  errEvseConfAbnormalState: {
    zh_cn: '设备响应的状态异常',
    en: 'Evse conf abnormal state',
    zhhant: '設備響應的狀態異常',
    he: 'מצב חריג בתגובה של EVSE',
    de: 'Abnormale EVSE-Konfiguration',
    es: 'Estado anormal de configuración de EVSE',
    ru: 'Аномальное состояние конфигурации EVSE',
    vi: 'Trạng thái cấu hình EVSE bất thường',
  },
  errEvseBusy: {
    zh_cn: '设备繁忙',
    en: 'Evse busy',
    zhhant: '設備繁忙',
    he: 'EVSE עסוק',
    de: 'EVSE beschäftigt',
    es: 'EVSE ocupado',
    ru: 'EVSE занят',
    vi: 'EVSE bận',
  },
  errEvseOccupy: {
    zh_cn: '设备占用',
    en: 'Evse occupy',
    zhhant: '設備佔用',
    he: 'EVSE תפוס',
    de: 'EVSE belegt',
    es: 'EVSE ocupado',
    ru: 'EVSE занят',
    vi: 'EVSE đang được sử dụng',
  },
  errNotExpectedConnectorState: {
    zh_cn: '不是预期的充电状态，不能发起充电',
    en: 'Not expected connector state',
    zhhant: '不是預期的充電狀態，不能發起充電',
    he: 'מצב מחבר לא צפוי, לא ניתן להתחיל טעינה',
    de: 'Unerwarteter Steckdosenstatus, Laden nicht möglich',
    es: 'Estado del conector no esperado, no se puede iniciar la carga',
    ru: 'Неожиданное состояние разъема, зарядка не может быть начата',
    vi: 'Trạng thái kết nối không mong đợi, không thể bắt đầu sạc',
  },
  errEvseStartParamError: {
    zh_cn: '启动充电的信息不充足',
    en: 'Evse start param error',
    zhhant: '啟動充電的信息不充足',
    he: 'פרמטרים לא מספיקים להתחלת טעינה',
    de: 'Fehlerhafte EVSE-Startparameter',
    es: 'Información insuficiente para iniciar la carga',
    ru: 'Недостаточные параметры для начала зарядки',
    vi: 'Thông tin khởi động sạc không đầy đủ',
  },
  errMissingEvseInfo: {
    zh_cn: '缺少设备信息',
    en: 'Missing evse info',
    zhhant: '缺少設備信息',
    he: 'חסר מידע על EVSE',
    de: 'Fehlende EVSE-Informationen',
    es: 'Información de EVSE faltante',
    ru: 'Отсутствует информация об EVSE',
    vi: 'Thiếu thông tin EVSE',
  },
  errNotHaveEvse: {
    zh_cn: '不拥有设备',
    en: 'Not have evse',
    zhhant: '不擁有設備',
    he: 'אין בעלות על EVSE',
    de: 'Kein Besitz von EVSE',
    es: 'No se tiene EVSE',
    ru: 'Не имеете EVSE',
    vi: 'Không sở hữu EVSE',
  },
  errUnsupportChangeCNum: {
    zh_cn: '不支持修改枪头数量',
    en: 'Unsupport change c num',
    zhhant: '不支持修改槍頭數量',
    he: 'שינוי מספר קונקטורים אינו נתמך',
    de: 'Änderung der Anzahl der Stecker nicht unterstützt',
    es: 'No se admite el cambio de número de conectores',
    ru: 'Изменение количества разъемов не поддерживается',
    vi: 'Không hỗ trợ thay đổi số lượng đầu cắm',
  },
  errUnsupportChangeSN: {
    zh_cn: '不支持修改SN',
    en: 'Unsupport change sn',
    zhhant: '不支持修改SN',
    he: 'שינוי SN אינו נתמך',
    de: 'Änderung der SN nicht unterstützt',
    es: 'No se admite el cambio de SN',
    ru: 'Изменение SN не поддерживается',
    vi: 'Không hỗ trợ thay đổi SN',
  },
  errOnlineCardNotSupport: {
    zh_cn: 'card',
    en: 'Online card not support',
    zhhant: 'card',
    he: 'כרטיס אונליין לא נתמך',
    de: 'Online-Karte nicht unterstützt',
    es: 'Tarjeta en línea no soportada',
    ru: 'Онлайн-карта не поддерживается',
    vi: 'Thẻ trực tuyến không được hỗ trợ',
  },
  errLocalCardNotSupport: {
    zh_cn: '离线线卡不支持',
    en: 'Local card not support',
    zhhant: '離線線卡不支持',
    he: 'כרטיס מקומי אינו נתמך',
    de: 'Lokale Karte nicht unterstützt',
    es: 'Tarjeta local no soportada',
    ru: 'Локальная карта не поддерживается',
    vi: 'Thẻ địa phương không được hỗ trợ',
  },
  errOrderPreStateIllegal: {
    zh_cn: '订单前置状态错误',
    en: 'Order pre state illegal',
    zhhant: '訂單前置狀態錯誤',
    he: 'הזמנה מבוקשת מצב לא חוקי',
    de: 'Bestellvorgang vorab ist nicht zulässig',
    es: 'El estado previo de la orden no es válido',
    ru: 'Предварительный статус заказа недопустимый',
    vi: 'Trạng thái trước đơn hàng không hợp lệ',
  },
  errConfigError: {
    zh_cn: '配置错误, 请联系管理员',
    zhhant: '配置錯誤, 請聯繫管理員',
    en: 'Config error, please contact admin',
    he: 'שגיאה בתצורה, אנא צור קשר עם מנהל',
    de: 'Konfigurationsfehler, bitte wenden Sie sich an den Administrator',
    es: 'Error de configuración, por favor contacta con el administrador',
    ru: 'Ошибка конфигурации, свяжитесь с администратором',
    vi: 'Lỗi cấu hình, vui lòng liên hệ với quản trị viên',
  },
  errMissingConfig: {
    zh_cn: '缺少配置信息, 请联系管理员',
    zhhant: '缺少配置信息, 請聯繫管理員',
    en: 'Missing config info, please contact admin',
    he: 'חסר מידע בתצורה, אנא צור קשר עם מנהל',
    de: 'Fehlende Konfigurationsinformationen, bitte wenden Sie sich an den Administrator',
    es: 'Información de configuración faltante, por favor contacta con el administrador',
    ru: 'Отсутствует информация конфигурации, свяжитесь с администратором',
    vi: 'Thiếu thông tin cấu hình, vui lòng liên hệ với quản trị viên',
  },
  errAccountBand: {
    zh_cn: '账号被禁用',
    zhhant: '賬號被禁用',
    en: 'Account banned',
    he: 'חשבון חסום',
    de: 'Konto gesperrt',
    es: 'Cuenta suspendida',
    ru: 'Аккаунт заблокирован',
    vi: 'Tài khoản bị cấm',
  },
  errGroupBand: {
    zh_cn: '集团被禁用',
    zhhant: '集團被禁用',
    en: 'Group banned',
    he: 'קבוצה חסומה',
    de: 'Gruppe gesperrt',
    es: 'Grupo suspendido',
    ru: 'Группа заблокирована',
    vi: 'Nhóm bị cấm',
  },
  errGroupMemberBand: {
    zh_cn: '集团被禁用',
    zhhant: '集團被禁用',
    en: 'Group member banned',
    he: 'חבר קבוצה חסום',
    de: 'Gruppenmitglied gesperrt',
    es: 'Miembro del grupo suspendido',
    ru: 'Участник группы заблокирован',
    vi: 'Thành viên nhóm bị cấm',
  },
  errGroupMemberNotFound: {
    zh_cn: '集团成员不存在',
    zhhant: '集團成員不存在',
    en: 'Group member not found',
    he: 'חבר קבוצה לא נמצא',
    de: 'Gruppenmitglied nicht gefunden',
    es: 'Miembro del grupo no encontrado',
    ru: 'Участник группы не найден',
    vi: 'Không tìm thấy thành viên nhóm',
  },
  errOperatorNotMatch: {
    zh_cn: '运营商不匹配',
    zhhant: '運營商不匹配',
    en: 'Operator not match',
    he: 'פסק זמן תגובה של התקן',
    de: 'Zeitüberschreitung der Antwort des Geräts',
    es: 'Tiempo de espera de respuesta del dispositivo agotado',
    ru: 'Превышено время ожидания ответа устройства',
    vi: 'Thời gian chờ phản hồi thiết bị quá hạn',
  },
  errStationEvseType: {
    zh_cn: '存在设备类型不一致的设备',
    zhhant: '存在設備類型不一致的設備',
    en: 'Exist evse type not match',
    he: 'פסק זמן תגובה של התקן',
    de: 'Zeitüberschreitung der Antwort des Geräts',
    es: 'Tiempo de espera de respuesta del dispositivo agotado',
    ru: 'Превышено время ожидания ответа устройства',
    vi: 'Thời gian chờ phản hồi thiết bị quá hạn',
  },
  errUnsupportFunc: {
    zh_cn: '设备不支持此功能',
    zhhant: '設備不支持此功能',
    en: 'Evse not support this function',
    he: 'פסק זמן תגובה של התקן',
    de: 'Zeitüberschreitung der Antwort des Geräts',
    es: 'Tiempo de espera de respuesta del dispositivo agotado',
    ru: 'Превышено время ожидания ответа устройства',
    vi: 'Thời gian chờ phản hồi thiết bị quá hạn',
  },
  errEvseRejected: {
    zh_cn: '设备拒绝',
    zhhant: '設備拒絕',
    en: 'Evse rejected',
    he: 'פסק זמן תגובה של התקן',
    de: 'Zeitüberschreitung der Antwort des Geräts',
    es: 'Tiempo de espera de respuesta del dispositivo agotado',
    ru: 'Превышено время ожидания ответа устройства',
    vi: 'Thời gian chờ phản hồi thiết bị quá hạn',
  },
  errEvseUnknown: {
    zh_cn: '设备未知状态',
    zhhant: '設備未知狀態',
    en: 'Evse unknown status',
    he: 'פסק זמן תגובה של התקן',
    de: 'Zeitüberschreitung der Antwort des Geräts',
    es: 'Tiempo de espera de respuesta del dispositivo agotado',
    ru: 'Превышено время ожидания ответа устройства',
    vi: 'Thời gian chờ phản hồi thiết bị quá hạn',
  },
  errNotFoundAvailableEvse: {
    zh_cn: '没有可用的设备',
    zhhant: '沒有可用的設備',
    en: 'Not found available evse',
    he: 'פסק זמן תגובה של התקן',
    de: 'Zeitüberschreitung der Antwort des Geräts',
    es: 'Tiempo de espera de respuesta del dispositivo agotado',
    ru: 'Превышено время ожидания ответа устройства',
    vi: 'Thời gian chờ phản hồi thiết bị quá hạn',
  },
  errNoData: {
    zh_cn: '无数据',
    zhhant: '無數據',
    en: 'No data',
    he: 'אין נתונים',
    de: 'Keine Daten',
    es: 'Sin datos',
    ru: 'Нет данных',
    vi: 'Không có dữ liệu',
  },
  errAmountInvalid: {
    zh_cn: '支付金额无效',
    zhhant: '支付金額無效',
    en: 'Payment amount invalid',
    he: 'סכום תשלום לא חוקי',
    de: 'Ungültige Zahlungsbetrag',
    es: 'Monto de pago inválido',
    ru: 'Некорректная сумма оплаты',
    vi: 'Số tiền thanh toán không hợp lệ',
  }
}
